(function () {
    "use strict";

    angular.module("app")
        .controller("QuarterlyForecasting",
            [
                "$scope", "$state", "cfpLoadingBar", "toaster", "PermissionService", "SharedData", "SeasonService", "WorkflowService",
                "PrototypeService", "ForecastingService", "DocumentService", quarterlyForecastingController
            ]);

    function quarterlyForecastingController($scope, $state, cfpLoadingBar, toaster, permissionService, sharedData, seasonService, workflowService,
        prototypeService, forecastingService, documentService) {
        var model = this;

        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }

        $scope.params = {};

        $scope.export = function () {
            $scope.params.salesRegionIds = _.chain($scope.salesRegions)
                .filter(function (r) { return r.selected })
                .map(function (r) { return r.SalesRegionId })
                .value();

            forecastingService.exportSalesForecast($scope.params).then(function (data) {
                if (data && data.length > 0)
                    documentService.openTempDocument(data, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "Quarterly Forecast Export.xlsx");
                else
                    toaster.pop({ type: "error", title: "Error!", body: "An unexpected error occurred exporting the file.", timeout: 5000 });
                return;
            });
        };

        $scope.import = function (e) {
            var file = e.files[0];
            $scope.importing = true;
            cfpLoadingBar.start();

            forecastingService.uploadSalesForecastDocument(file)
                .then(function () {
                    cfpLoadingBar.complete();
                    toaster.clear();
                    toaster.pop({ type: "success", title: "Upload Completed", body: "<a href='/upload-queue'>Upload successful! Click here to see upload progress and results.</a>.", bodyOutputType: "trustedHtml", timeout: 5000 });
                    $scope.importing = false;
                }, function () {
                    cfpLoadingBar.complete();
                    toaster.clear();
                    toaster.pop({ type: "error", title: "File Upload Error", body: "There was an error while uploading your file.", timeout: 5000 });
                    $scope.importing = false;
                });

            //clear file select
            $scope.documentInterface = {};
            document.getElementById('file0').value = null;
        };

        $scope.loadBrandData = function () {
            var brand = _.find($scope.brands, function (b) { return b.BrandId === $scope.params.brandId });

            $scope.params.divisionKey = null;
            $scope.params.prototypeGroupId = null;

            if (brand) {
                $scope.sapBrandId = brand.SAPBrandId;
                $scope.getSeasonsByBrand($scope.params.brandId);
                workflowService.getWFGroups($scope.params.brandId, 4).then(function (data) { $scope.prototypeGroups = data; });
            } else {
                $scope.sapBrandId = null;
                $scope.seasons = [];
                $scope.prototypeGroups = [];
            }
        };

        $scope.getSeasonsByBrand = function (brandId) {
            return seasonService.getSeasonsByBrand(brandId).then(function (data) {
                $scope.seasons = data;
            });
        };

        model.init = function () {
            if (!permissionService.canReadQuarterlyForecasting()) {
                $state.go('permissionDenied');
            }

            $scope.canImport = permissionService.canEditQuarterlyForecasting();

            sharedData.getUserDefaults().then(function (userDefaults) {
                if (userDefaults) {
                    $scope.brands = userDefaults.brands;
                    $scope.seasons = userDefaults.seasons;
                    $scope.params.brandId = userDefaults.brandId;
                    $scope.params.seasonId = userDefaults.seasonId;

                    if (userDefaults.brandId) {
                        $scope.loadBrandData();
                        $scope.params.divisionKey = userDefaults.divisionKey;
                    }

                    cfpLoadingBar.complete();
                }
            });

            prototypeService.getSalesRegions().then(function (data) {
                $scope.salesRegions = data.Data;
            });
        };

       // model.init();
    }
})();
